import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransferenciaCreditoClienteJanelaComponent } from './transferencia-credito-cliente-janela.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: TransferenciaCreditoClienteJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class TransferenciaCreditoClienteJanelaRoutingModule { }
